<template>
    <div class="confirm">
        <div v-if="STEP==0">
            <div class="title">
                <div>等待体检</div>
                <div>请于 {{orderTime}} 至现场取号体检</div>
            </div>
            <div class="info">
                <ul>
                    <li>
                        <b>•基本信息</b>
                        <div><span class="textright">体检套餐：</span><span>{{TYPE}}</span></div>
                        <div><span class="textright">体检人：</span><span>{{NAME}}</span></div>
                        <div>
                            <span class="textright">联系电话：</span><span>{{PHONE_NUM}}</span>
                        </div>
                    </li>
                    <li>
                        <b>•费用详情</b>
                        <h1>基础项目</h1>
                        <div class="tables">
                            <table>
                                <thead>
                                    <tr>
                                        <td>序号</td>
                                        <td>项目</td>
                                        <!-- <td>价格</td> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(li,index) in basicItems" :key="index"  v-tip.click="getTip1(li,index)" :class="{rowactive:selIndex0==index}">
                                        <td>{{index+1}}</td>
                                        <td style="max-width:8em;">{{li.CHECKITEM_NAME}}</td>
                                        <!-- <td>{{li.ITEM_COST}}</td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <h1>新增项目</h1>
                        <div class="tables">
                            <table>
                                <thead>
                                    <tr>
                                        <td>序号</td>
                                        <td>项目</td>
                                        <td>价格</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(li,index) in addItems" :key="index" v-tip.click="getTip2(li,index)" :class="{rowactive:selIndex1==index}">
                                        <td>{{index+1}}</td>
                                        <td style="max-width:8em;">{{li.CHECKITEM_NAME}}</td>
                                        <td>{{li.ITEM_COST}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </li>
                    <li>
                        <h1>预约须知</h1>
                        <ul class="info2">
                            <li>1.请合理安排您的预约时间，按时体检。</li>
                            <li>2.若需改约，请提前24小时致电客服改约，联系电话：0512-56995618，谢谢。</li>
                            <!-- <li>3.提供准确的早期预警，让您更好的了解目前身体状况。</li> -->
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="yuyue">
                <!-- <button @click="tuikuan" class="tuikuan"> 发起退款</button> -->
                <button @click="goGaiYue" class="tuikuan">改约</button>
                <button @click="goQuxiao" class=" blue">取消预约</button>
            </div>
        </div>
        <van-popup v-model="showPop" position="bottom">
            <van-picker show-toolbar :columns="pops" @confirm="confirmQX" @cancel="showPop = false" id="pops" />
        </van-popup>
        <!-- <div v-else-if="STEP==1">
                            <singleYuYue @steps="watchStep"></singleYuYue>
                        </div>
                        <div v-else>
                             <yuyueSuccess></yuyueSuccess>
                            
                        </div> -->
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex';
    import {
        Dialog,
        Popup,
        Toast
    } from 'vant';
    import api from "@/fetch/api";
    // import singleYuYue from '@/pages/singleYuYue';
    // import yuyueSuccess from '@/pages/yuyueSuccess'
    const tips = {
        //template: `<div class="iteminfo"><div class="top"><i class="iconfont icon-error" @click="handler2"></i></div><van-cell-group class="tip"><van-cell title="项目名称：" v-model="ITEM_NAME" /><van-cell title="价格：" v-model="PRICE" /></van-cell-group></div> `,
        template: `<div class="iteminfo"><div class="top"><i class="iconfont icon-error" @click="handler2"></i></div><van-cell-group class="tip"><van-cell title="项目名称：" v-model="ITEM_NAME" /></van-cell-group></div> `,
        props: {
            ITEM_NAME: String,
            PRICE: Number,
            handler: Function,
            SEL_INDEX: Number
        },
        created() {
            this.$emit('sel', this.SEL_INDEX)
        },
        methods: {
            handler2() {
                this.$emit('close')
            }
        },
    }
    export default {
        data() {
            return {
                TYPE: '',
                NAME: '',
                PHONE_NUM: '',
                orderID: '',
                addItems: [],
                basicItems: [],
                orderTime: '',
                totalPrice: 0,
                STEP: 0,
                showPop: false,
                pops: ['我不想买了', '信息填写错误', '另选套餐', '其他原因'],
                selIndex0: -1,
                selIndex1: -1,
            }
        },
        // components: {
        //     singleYuYue,yuyueSuccess
        // },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getOrderInfo(vm)
            })
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
            getOrderInfo(el) {
                this.orderID = el.$route.params.orderID;
                var record = JSON.parse(sessionStorage.getItem('records'));
                this.TYPE = record.TYPE;
                this.NAME = record.NAME;
                this.PHONE_NUM = record.PHONE_NUM;
                this.orderTime=record.PRESET_TIME;
                console.log(record.PRESET_TIME);
                api.queryMyOrderItems(this.orderID).then(re => {
                    let data = re.data;
                    this.addItems = data.addItems;
                    this.basicItems = data.basicItems;
                });
                this.totalPrice = parseFloat(record.PRICE);
            },
            goGaiYue() {
                sessionStorage.setItem('records', sessionStorage.getItem('records'));
                this.$router.push('/user/singleYuYue/' + this.orderID);
                // this.STEP=1;
            },
            tuikuan() {
                Dialog.confirm({
                    title: '退款',
                    message: '确定退款吗？'
                }).then(() => {
                    Toast.loading({
                        mask: true,
                        message: '处理中...'
                    });
                    setTimeout(() => {
                        Toast.success('退款成功！');
                    }, 3000);
                }).catch(() => {
                    // on cancel
                });
            },
            goQuxiao() {
                this.showPop = true;
            },
            confirmQX() {
                api.cancelOrder(this.orderID).then(re => {
                    if (re.result == true) {
                        this.showPop = false;
                        Toast.success('欢迎下次光临');
                        this.$router.back(-1);
                    }
                });
            },
            watchStep(val) {
                console.log(val);
                this.STEP = val;
            },
            getTip(obj) {
                let that = this;
                return {
                    width: '80%',
                    transition: true,
                    container: document.getElementById('app'),
                    // 优先在 top bottom 方向上显示
                    placements: ['top', 'bottom'],
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        handler() {
                            that.tipsHidden();
                        }
                    },
                    customListeners: {},
                    customComponent: tips
                }
            },
            tipsHidden() {
                const tipInstance = this.$tip(this.tips);
                tipInstance.hiddenTip(true);
            },
             getTip1(obj, index1) {
                let that = this;
                return {
                    width: '80%',
                    transition: false,
                    container: document.getElementById('app'),
                    // 优先在 top bottom 方向上显示
                    placements: ['top', 'bottom'],
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        SEL_INDEX: index1,
                        handler() {
                            that.tipsHidden();
                        }
                    },
                    duration: 30,
                    customListeners: {
                        sel(val) {
                            that.selIndex0 = val;
                            that.selIndex1 = -1;
                            console.log(that.selIndex0)
                        },
                        close() {
                            that.tipsHidden();
                        }
                    },
                    customComponent: tips
                };
            },
            getTip2(obj, index2) {
                let that = this;
                return {
                    width: '80%',
                    transition: false,
                    container: document.getElementById('app'),
                    // 优先在 top bottom 方向上显示
                    placements: ['top', 'bottom'],
                    customProps: {
                        ITEM_NAME: obj.CHECKITEM_NAME,
                        PRICE: obj.ITEM_COST,
                        SEL_INDEX: index2,
                        handler() {
                            that.tipsHidden();
                        }
                    },
                    duration: 30,
                    customListeners: {
                        sel(val) {
                            that.selIndex0 = -1;
                            that.selIndex1 = val;
                            console.log(that.selIndex1)
                        },
                        close() {
                            console.log(that)
                            that.tipsHidden();
                        }
                    },
                    customComponent: tips
                };
            }
        },
    }
</script>

<style scoped lang='less'>
    .confirm {
        .yuyue {
            position: fixed;
            bottom: 0;
            width: 100%;
            border-top: 1px solid #ccc;
            height: 3em;
            line-height: 3em;
            color: #43852E;
            font-size: 0.8rem;
            background: #fff;
            text-align: right;
            right: 0;
            padding-right: 1em;
            .btnbuy {
                padding: 0 1em;
            }
            button {
                border-radius: 10px;
                border: 1px solid #ccc;
                color: #666;
                width: 6em;
                text-align: center;
                line-height: 1.8em;
                margin-bottom: 0.4em;
                background: #fff;
                padding: 0;
            }
            .blue {
                color: #99C51D;
                border-color: #99C51D;
            }
        }
        .tables {
            border: 0;
            width: 100%;
            padding: 0;
            margin: 0;
             .rowactive {
                background: #FF7C3E;
                td {
                    color: #fff !important;
                }
            }
            td {
                height: 1.8em !important;
                border-bottom: 1px solid rgb(226, 226, 226);
                color: #999 !important;
            }
        }
        .title {
            // height: 2em;
            font-size: 0.95rem;
            border-width: 4px;
            border-style: solid;
            border-color: #43852E; // border-top: 0px;
            // border-right: 0px;
            // border-bottom: 0px;
            border: 0;
            border-radius: 0px;
            line-height: 2em;
            padding-left: 1em;
            font-weight: bold;
            border-bottom: 1px solid rgb(226, 226, 226); // color: #666;
            color: #fff;
            background-color: rgba(255, 153, 102, 1);
            div {
                text-align: center;
            }
        }
        li {
            color: #99C51D;
            font-size: 0.8rem;
            padding: 0.5em 1em;
            b {
                line-height: 2em;
            }
            >h1 {
                background: rgba(246, 246, 246, 1);
                font-size: 0.8rem;
                line-height: 3em;
                height: 3em;
                color: #333;
                text-align: center;
                font-weight: normal;
            }
            >div {
                color: #666;
                line-height: 2em;
                span {
                    display: inline-block;
                    min-width: 6em;
                    margin-right: 1em;
                }
                padding-bottom: 0.5em;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/confirmTJ.vue